import { AssignmentOutlined as AssignmentIcon, DescriptionOutlined as DescriptionIcon } from '@mui/icons-material';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

const seg = {
  root: 'engagement-letters',
  home: '',
  client: 'clients',
  clientId: ':clientId',
  waiver: 'waivers',
  waiverId: ':waiverId',
  relatedClient: 'related-clients',
  relatedClientId: ':relatedClientId',
} as const;

export const engagementLetterDatabaseRoutes = {
  segment: seg.root,
  path: `/${seg.root}`,
  label: 'Engagement Letter Database',
  icon: DescriptionIcon,
  isPortalApp: true,
  navItems: [
    {
      id: 'eld-engagement-letter',
      name: 'Engagement Letters',
      path: `/${seg.root}`,
      icon: DescriptionIcon,
    },
    {
      id: 'eld-waiver',
      name: 'Waiver Letters',
      path: `/${seg.root}?letterType=waiver`,
      icon: AssignmentIcon,
    },
  ],
  home: {
    segment: seg.home,
    path: `/${seg.root}`,
    label: 'Home',
    icon: HomeOutlinedIcon,
  },
  relatedClient: {
    segment: `${seg.relatedClient}/${seg.relatedClientId}`,
    path: `/${seg.root}/${seg.relatedClient}/${seg.relatedClientId}`,
    label: 'Related Client',
    icon: FolderSharedOutlinedIcon,
  },
  client: {
    segment: `${seg.client}/${seg.clientId}`,
    path: `/${seg.root}/${seg.client}/${seg.clientId}`,
    label: 'Client',
    icon: FolderSharedOutlinedIcon,
  },
  waiver: {
    segment: `${seg.waiver}/${seg.waiverId}`,
    path: `/${seg.root}/${seg.waiver}/${seg.waiverId}`,
    label: 'Waiver',
    icon: FolderSharedOutlinedIcon,
  },
};

export type EngagementLetterDatabaseRoutes = typeof engagementLetterDatabaseRoutes;
